<template>
  <div class="discussion">
    <h1>Interactive Q&A</h1>
  <div>
    <el-input v-model="search" placeholder="Search for a question"/>
    </div>
    <el-form class="add-question" ref="add-question" :model="question">
      <div class="ask-question">
        <el-input v-model="question.question" placeholder="Ask your question" />

        <el-button @click="addQuestion" plain>Add Question</el-button>
      </div>
    </el-form>
    
    <div v-loading="loading" element-loading-background="white">
    <div  class="infinite-list" v-if="questions.length > 0 || loading" v-infinite-scroll="load" style="overflow:auto;">
      <div v-bind:key="question.id" v-for="question in this.questions">
      <Question v-on:delete-question="deleteQuestion" v-bind:question="question" />
    </div>
    </div>
    <div v-else>
      <h3> No results</h3>
      </div>
    </div>
    
  </div>
</template>

<script>
import Question from "../components/Question.vue";
import axios from "axios";
export default {
  name: "QA",
  components: {
    Question
  },
  data() {
    return {
      questions: [],
      allQuestions: [],
      search: "",
      loading: true,
      question: {
        question: ""
      }
    };
  },
  created() {
    this.getData()
  },
  watch : {
    search(value){
      let search = value.toLowerCase()
      this.questions = this.allQuestions.filter(question => question.string.toLowerCase().includes(search))
      console.log(this.questions)
    },
  },
  methods: {
    getData() {
      axios
      .get("https://team16app1.herokuapp.com/get_data")
      .then((res) => {
        this.allQuestions = res.data;
        this.allQuestions = res.data.map(question => {
          return {
            ...question,
            timestamp: new Date(question.time * 1000),
            string: question.question + question.answer
          };
        });
        this.loading = false
        this.questions = this.allQuestions

        console.log(this.questions)
      })
      .catch(err => console.log(err));
    },
    addQuestion() {
      const newQuestion = {
        question: this.question.question,
        answered: false,
        answer: ""
      };

      axios
        .post("https://team16app1.herokuapp.com/add_question", newQuestion)
        .then(() => {
          this.getData()
        })
        .catch(err => console.log(err));

        this.question.question = ""

        this.$notify({
          title: 'Your question has been submitted',
          type: 'success'
        });
    },

    deleteQuestion(id) {

      axios
        .post("https://team16app1.herokuapp.com/delete_question", id)
        .then(() => {
          this.getData()
        })
        .catch(err => console.log(err));
    }
  }
};
</script>

<style scoped>
.discussion {
  margin-left: 100px;
  margin-right: 100px;
  padding-top: 50px;
}

.ask-question {
  display: flex;
  flex-direction: row;
  margin-top: 20px;
}
</style>